import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { BodyText, Caption, Heading2, LinkText, Subtitle } from '../Typography';

import { SocialLinks } from '../../constants/constants';
import GoogleMap from './GoogleMap';
import FacebookFeed from './FacebookFeed';

const Footer2 = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 px-6 py-10 text-white md:px-12">
      <div className="container mx-auto grid grid-cols-1 gap-8 md:grid-cols-6">
        {/* Company Info */}
        <div className="col-span-3 flex flex-col gap-4 space-y-4">
          <div>
            <Heading2 className="mb-4 text-xl font-bold text-white">
              MB AUTOCARE GARAGE
            </Heading2>
            <BodyText className="font-normal leading-loose tracking-widest text-white md:w-2/3">
              Serving your community since 2000 with trusted and expert car
              repair services. Committed to quality and customer satisfaction.
            </BodyText>
          </div>
          {/* buttons */}
          <div className="flex gap-2 space-x-4 md:gap-4">
            <a href={SocialLinks.phone} className="rounded-md bg-white p-2">
              <StaticImage
                src="../../images/icons/phone.svg"
                alt="Phone"
                className="h-8 w-8"
              />
            </a>
            <a href={SocialLinks.fb} className="rounded-md bg-white p-2">
              <StaticImage
                src="../../images/icons/facebook.svg"
                alt="Facebook"
                className="h-8 w-8"
              />
            </a>
            <a href={SocialLinks.whatsapp} className="rounded-md bg-white p-2">
              <StaticImage
                src="../../images/icons/whatsapp.svg"
                alt="Whatsapp"
                className="h-8 w-8"
              />
            </a>
            <a href={SocialLinks.map} className="rounded-md bg-white p-2">
              <StaticImage
                src="../../images/icons/navigation.svg"
                alt="Navigation"
                className="h-8 w-8"
              />
            </a>
          </div>

          <div className="grid grid-cols-2 items-start justify-start space-x-4 md:grid-cols-5">
            {/* google map */}
            <div className="md:col-span-2">
              {/* <iframe
                className="h-40 w-full rounded-md"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d23727.045468109343!2d-2.1868613489449693!3d53.02647967814168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487a4f55eeb8e9c9%3A0x836f7df737d38a15!2sStoke-on-Trent%2C%20UK!5e0!3m2!1sen!2s!4v1620307797837!5m2!1sen!2s"
                width="100%"
                height="200"
                style={{ border: 0 }}
                // allowFullScreen=""
                loading="lazy"
              ></iframe> */}
              <GoogleMap />
            </div>

            {/* Location */}
            <div className="flex flex-col px-4 md:col-span-3">
              <Subtitle className="mb-4 font-semibold tracking-widest text-white md:text-lg">
                LOCATION
              </Subtitle>
              <a href={SocialLinks.map} className="text-white hover:underline">
                <BodyText className="leading-relaxed tracking-wider text-white md:leading-loose">
                  <span className="md:whitespace-nowrap">
                    UNIT 5 MAPLEHURST CLOSE
                  </span>
                  <br />
                  BURSLEM <br />
                  STOKE-ON-TRENT <br />
                  ST6 2EJ
                </BodyText>
              </a>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="col-span-3 grid grid-cols-2 md:col-span-1">
          <div className="flex flex-col gap-3 md:col-span-2">
            <Subtitle className="mb-2 font-semibold tracking-widest text-white md:text-lg">
              QUICK LINKS
            </Subtitle>
            <LinkText
              to="/"
              className="text-base font-normal capitalize tracking-wider"
            >
              Home
            </LinkText>
            <LinkText
              to="/about"
              className="text-base font-normal capitalize tracking-wider"
            >
              About
            </LinkText>
            <LinkText
              to="/services"
              className="text-base font-normal capitalize tracking-wider"
            >
              Services
            </LinkText>
            <LinkText
              to="/contact"
              className="text-base font-normal capitalize tracking-widest"
            >
              Contact
            </LinkText>
            <LinkText
              to="/faq"
              className="text-base font-normal capitalize tracking-widest"
            >
              FAQ's
            </LinkText>
            <LinkText
              to="/sitemap"
              className="text-base font-normal capitalize tracking-widest"
            >
              Sitemap
            </LinkText>
          </div>
          {/* Contact */}
          {/* <div className="flex flex-col gap-2 md:col-span-2 md:space-y-2">
            <Subtitle className="font-semibold tracking-widest md:text-lg">
              CONTACT
            </Subtitle>
            <LinkText to={`tel:${tele}`} Icon={ContactIcon}>
              {tele}
            </LinkText>
            <LinkText
              to={`whatsapp:${whtapp}`}
              iconClassName="bg-green-400 rounded-full"
              Icon={WhatsappIcon}
            >
              {whtapp}
            </LinkText>
          </div> */}
        </div>
        {/* <div className="col-span-1 flex md:col-span-2 md:items-center md:justify-center">
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmbautocaregarage&tabs=timeline&width=300&height=450&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            width="300"
            height="450"
            // style="border:none;overflow:hidden"
            scrolling="no"
            // frameborder="0"
            // allowfullscreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          ></iframe>
        </div> */}
        <div className="col-span-1 flex md:col-span-2 md:items-center md:justify-center">
          {/* <FacebookFeed /> */}
          <FacebookFeed />
        </div>
      </div>

      <div className="mt-10 border-t border-gray-700 pt-6 text-center">
        <Caption className="text-sm">
          &copy; {currentYear} MB Autocare Garage, All Rights Reserved. Powered
          by{' '}
          <span className="whitespace-nowrap">
            <a
              href="https://www.instagram.com/twobrothers.uk"
              target="_blank"
              className="hover:underline"
            >
              Two Brothers
            </a>
          </span>
        </Caption>
        <div className="flex justify-center space-x-4">
          <LinkText to="/privacy" className="hover:underline">
            Terms & Privacy Policy
          </LinkText>
          <LinkText to="/cookie-policy" className="hover:underline">
            Cookie Policy
          </LinkText>
        </div>
      </div>
    </footer>
  );
};

export default Footer2;
